import { render } from "./page_10.vue?vue&type=template&id=a5d1039e&scoped=true"
import script from "./page_10.vue?vue&type=script&lang=js"
export * from "./page_10.vue?vue&type=script&lang=js"

import "./page_10.vue?vue&type=style&index=0&id=a5d1039e&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d1039e"]])

export default __exports__